export enum Role {
  CREATOR = "creator",
  ADMIN = "admin",
  USER = "user",
  INTERNAL = "internal",
}
